<template>
  <v-container class="col-12">
    <v-card class="px-2">
      <v-row>
        <v-col cols="2">
          <select-project
            v-if="!options.hideProjectSelector && !options.projectSearch"
            v-model="project"
            :class="{'report-base-filter': !options.multiple, 'report-multiple-combobox': options.multiple}"
            :multiple="options.multiple"
            single-line
            :show-select-all="options.showSelectAll"
            :loading="isLoading"
          />
        </v-col>
        <v-col cols="2">
          <v-select
            v-if="!options.hideDate"
            :items="dateRangeList"
            :value="dateRangeList[0]"
            :loading="isLoading"
            class="report-base-filter"
            hide-details
            label="Period"
            @change="changeTimePeriod"
          />
        </v-col>
        <v-col cols="2">
          <date-picker
            v-if="!options.hideDate || options.singleDate"
            v-model="from"
            label="Date From"
            hide-details
            :loading="isLoading"
          />
        </v-col>
        <v-col cols="2">
          <date-picker
            v-if="!options.hideDate"
            v-model="to"
            label="Date To"
            hide-details
            :loading="isLoading"
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex align-center"
        >
          <v-btn-toggle
            v-model="groupBy"
            color="primary"
            mandatory
            dense
          >
            <v-btn
              value="day"
            >
              Day
            </v-btn>
            <v-btn
              value="week"
            >
              Week
            </v-btn>
            <v-btn
              value="month"
            >
              Month
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col class="d-flex align-center" cols="2">
          <v-btn
            color="info"
            @click="onSearch"
          >
            Search
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-row class="mt-2">
      <v-col cols="3">
        <v-card
          style="border-top: 5px solid #4caf50"
          :loading="isLoading"
        >
          <v-card-subtitle>
            Total LP earned
          </v-card-subtitle>
          <v-card-title>
            {{ summary.total_earned || 'N/A' }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card
          style="border-top: 5px solid #ff9e48"
          :loading="isLoading"
        >
          <v-card-subtitle>
            Total LP used
          </v-card-subtitle>
          <v-card-title>
            {{ summary.total_used || 'N/A' }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card
          style="border-top: 5px solid #1867c0"
          :loading="isLoading"
        >
          <v-card-subtitle>
            Net LP balance
          </v-card-subtitle>
          <v-card-title>
            {{ summary.net_balance || 'N/A' }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card
          style="border-top: 5px solid #eb5757"
          :loading="isLoading"
        >
          <v-card-subtitle>
            Active users
          </v-card-subtitle>
          <v-card-title>
            {{ summary.total_accounts || 'N/A' }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="analytics"
          :loading="isLoading"
        >
          <template #item.row_num="{ index }">
            <span>{{ index + 1 }}</span>
          </template>

          <template #header.total_earned="{header}">
            <span>
              {{ header.text }} <v-icon color="primary">mdi-plus-circle-outline</v-icon>
            </span>
          </template>

          <template #header.total_used="{header}">
            <span>
              {{ header.text }} <v-icon color="warning">mdi-minus-circle-outline</v-icon>
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
import DatePicker from '@/components/core/DatePicker/DatePicker.vue'
import { API } from '@/utils/api'

export default {
  props: {
    title: {},
    headers: {},
    projectList: {
      default: () => ([])
    },
    filters: {},
    url: {},
    defaultParams: {
      default: () => ({})
    },
    nowrap: {
      default: true
    },
    table_size_fixed: {
      default: false
    },
    options: {
      default: () => ({})
    },
  },
  components: {
    SelectProject,
    DatePicker,
  },

  data() {
    return {
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      summary: {},
      analytics: [],
      dateRangeList,
      project: this.options.multiple ? [] : null,
      groupBy: 'day',
      isLoading: false,
    }
  },

  methods: {
    changeTimePeriod: function (value) {
      this.from = value.from
      this.to = value.to
    },

    onSearch() {
      this.isLoading = true

      return API.call(this.url, {
        from: this.from,
        to: this.to,
        groupBy: this.groupBy,
      }, null, Array.isArray(this.project) ? this.project[0] : this.project)
        .then(r => {
          this.summary = r.data.summary
          this.analytics = r.data.analytics
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table th {
    &.used {
      > span {
        color: #ff9e48;
      }
      border-top: 3px solid #ff9e48;
    }

    &.earned {
      > span {
        color: #4caf50;
      }
      border-top: 3px solid #4caf50;
    }
  }
}
</style>
